// dsParam.js
// @author: anghello

const STORAGE_KEY = 'pz_user_identifiable_pcm_v1';
const CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

let userIdentifiableCache = null;

function pad2(value) {
  return String(value).padStart(2, '0');
}

function formatUtcDate(date = new Date()) {
  const year = date.getUTCFullYear();
  const month = pad2(date.getUTCMonth() + 1);
  const day = pad2(date.getUTCDate());
  const hour = pad2(date.getUTCHours());
  const minute = pad2(date.getUTCMinutes());
  const second = pad2(date.getUTCSeconds());
  return `${year}${month}${day}-${hour}${minute}${second}`;
}

function generateRandomSuffix(length = 6) {
  const arr = CHARS.split('');
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  return arr.slice(0, length).join('');
}

function persistUserIdentifiable(value) {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(STORAGE_KEY, value);
    }
  } catch (_) {
    // localStorage can be blocked; keep memory fallback.
  }
}

function readStoredUserIdentifiable() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem(STORAGE_KEY);
    }
  } catch (_) {
    // localStorage can be blocked; return null.
  }
  return null;
}

export function getUserIdentifiable() {
  if (userIdentifiableCache) {
    return userIdentifiableCache;
  }

  const storedValue = readStoredUserIdentifiable();
  if (storedValue) {
    userIdentifiableCache = storedValue;
    return userIdentifiableCache;
  }

  const date = formatUtcDate(new Date());
  const uniqueID = generateRandomSuffix(6);
  userIdentifiableCache = `${date}-${uniqueID}`;
  persistUserIdentifiable(userIdentifiableCache);

  return userIdentifiableCache;
}

export function buildDsParam(app, client) {
  const safeAppRaw = (app || '').toString().trim();
  const safeClientRaw = (client || '').toString().trim().toUpperCase();

  const safeClient = safeClientRaw.replace(/[^A-Za-z]/g, '').slice(0, 5);
  const safeApp = safeAppRaw.replace(/[^A-Za-z0-9_]/g, '').slice(0, 10);

  if (!safeApp || !safeClient) {
    return '';
  }

  const userIdentifiable = getUserIdentifiable();
  const ds = `${safeClient}-${safeApp}-${userIdentifiable}`;

  const dsValidationPattern = /^[A-Za-z]{1,5}-[A-Za-z0-9_]{1,10}-\d{8}-\d{6}-[A-Za-z0-9]{6}$/;
  if (!dsValidationPattern.test(ds)) {
    return '';
  }

  return ds;
}
